import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Modal, Box, Tab, Typography, TextField, InputAdornment, IconButton } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { gridSpacing } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import MailerList from '../components/Scheduler/MailerList';
import AllMailerList from '../components/Scheduler/AllMailerList';

const ScheduleReportPage = ({ email, user_role }) => {
  const [value, setValue] = useState('1');
  const [searchQuery, setSearchQuery] = useState('');

  const isAdmin = user_role === 'admin';

  const handleChange = (event, newValue) => {
    // Prevent switching to admin tab if not admin
    // if (newValue === '2' && !isAdmin) {
    //   return;
    // }
    setValue(newValue);
    // Clear search when switching tabs
    setSearchQuery('');
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
  };

  useEffect(() => {
    console.log('email', email);
  }, []);

  return (
    <>
      <MainCard title="Schedule Report">
        <Grid container spacing={gridSpacing}>
          <Grid item xs={12}>
            <TabContext value={value}>
              {/* Fixed Tab Header with Search */}
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  position: 'sticky',
                  top: 0,
                  backgroundColor: 'white',
                  zIndex: 100,
                  paddingBottom: 1
                }}
              >
                {/* Tab Navigation */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <TabList onChange={handleChange} aria-label="Page tabs">
                    <Tab label="My Scheduled Reports" value="1" />
                    {/* {isAdmin && <Tab label="All Scheduled Reports" value="2" />} */}
                    <Tab label="All Scheduled Reports" value="2" />
                  </TabList>

                  {/* Search Bar */}
                  <Box sx={{ minWidth: 500 }}>
                    <TextField
                      size="small"
                      placeholder={value === '1' ? 'Search your reports, advertisers...' : 'Search for users, reports, advertisers...'}
                      // placeholder="Search reports, advertisers or users..."
                      value={searchQuery}
                      onChange={handleSearchChange}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon color="action" />
                          </InputAdornment>
                        ),
                        endAdornment: searchQuery && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={handleClearSearch} edge="end">
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#f5f5f5',
                          '&:hover': {
                            backgroundColor: '#eeeeee'
                          },
                          '&.Mui-focused': {
                            backgroundColor: 'white'
                          }
                        }
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Scrollable Tab Content */}
              <Box
                sx={{
                  height: 'calc(100vh - 300px)', // Adjust based on your header height
                  overflow: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '8px'
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                    borderRadius: '4px'
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: '#c1c1c1',
                    borderRadius: '4px',
                    '&:hover': {
                      backgroundColor: '#a8a8a8'
                    }
                  }
                }}
              >
                <TabPanel value="1" sx={{ padding: 0, paddingTop: 2 }}>
                  <MailerList searchQuery={searchQuery} />
                </TabPanel>
                <TabPanel value="2" sx={{ padding: 0, paddingTop: 2 }}>
                  <AllMailerList searchQuery={searchQuery} />
                </TabPanel>
              </Box>
            </TabContext>
          </Grid>
        </Grid>
      </MainCard>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    email: state.userReducer.userEmail,
    user_role: state.advertiserReducer.user_type
  };
};

export default connect(mapStateToProps, null)(ScheduleReportPage);
